export default __webpack_public_path__ + "static/east-main-video2-d16f49e9dd8ab2ee30f2477d5f52cfd4.jpg";